import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { AlertService } from 'src/app/providers/alert.service';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-mark-absent',
  templateUrl: './mark-absent.component.html',
  styleUrls: ['./mark-absent.component.scss']
})
export class MarkAbsentComponent implements OnInit,OnDestroy {
  absentDate:any
  notes:any = null
  apisub:Subscription
  constructor(private activemodal: MatDialogRef<MarkAbsentComponent>,private _alertService:AlertService,@Inject(MAT_DIALOG_DATA) public parentdata:any, private apiservice:ApiService, private ls: LoaderServiceService) { 
    this.apisub = this.apiservice.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_MARK_MEMBER_ABSENT_BY_ENTITY){
        if(resdata.result){
          this.ls.showLoader = false
          this._alertService.onOpenSnackbar('Attendance marked successfully.');
          this.activemodal.close()
        }
      }
    })


  }

  ngOnInit(): void {
  }

  onpost(){
    let data = {
      "entityHash": this.parentdata.entityHash,
      created_by_hash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
      "memberHash": this.parentdata.memberHash,
      "attendanceDate": this.formatDateString(this.absentDate),
      "notes": this.notes
    }
    Object.keys(data).forEach(key => {
      if ((data as any)[key] === null) {
        delete (data as any)[key];
      }
    });
    console.log(data);
    this.ls.showLoader = true
    this.apiservice.markMemberAbsentByEntity(data)
  }

  formatDateString(inputDateString: Date): string {
    const inputDate = new Date(inputDateString);
    const time = new Date()
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
    const day = inputDate.getDate().toString().padStart(2, '0');
    const hours = time.getHours().toString().padStart(2, '0');
    const minutes = time.getMinutes().toString().padStart(2, '0');
    const seconds = time.getSeconds().toString().padStart(2, '0');
  
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe()
  }

}
